import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PurchaseReturnForm from './NewPurchaseReturnForm';


import * as purchaseActions from './../../../actions/purchaseActions';

class NewPurchaseReturn extends React.Component {

   render() {
      return (
         <div className="NewPurchaseReturn" >
            <h1>New Purchase Return</h1>
            <PurchaseReturnForm />
         </div>
      );
   }
}

NewPurchaseReturn.propTypes = {};


function mapStateToProps() {
   return {
      purchases: []
   };
}

function mapDispatchToProps(dispatch) {
   return {
      actions: bindActionCreators(purchaseActions, dispatch)
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(NewPurchaseReturn);



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/PurchaseReturn/NewPurchaseReturn.js
 **/